import { IntegrationType } from '../@types/config'
import { FlowMachineContext } from '../state/flowMachine'
import { STEP } from '../@types/state'

export const getAdditionalSkippedStepsForImmoverkauf24 = (ctx: FlowMachineContext): STEP[] => {
  const { lead, integrationType } = ctx
  const skippedSteps: STEP[] = []

  if (integrationType == IntegrationType.IMMOVERKAUF24 && lead?.intent) {
    skippedSteps.push(STEP.DEV_COM_OFFER)
    skippedSteps.push(STEP.PARTIAL_SALE)
    skippedSteps.push(STEP.INTENT)
  }

  return skippedSteps
}
